import { Component, OnInit, Input, ViewChild, Output, EventEmitter  } from '@angular/core';
import { DateTimeFunctions } from "src/app/shared/datetime-functions";
import DataSource from 'devextreme/data/data_source';
import { DxDataGridComponent } from "devextreme-angular";
import { confirm } from 'devextreme/ui/dialog';
import { GridEditWeekComponent } from '../../../../../shared/components/grid-edit-week/grid-edit-week.component';
import { UserService } from '../../../../../shared/services/user.service';
import { ProjectService } from '../../../_api/services/project.service';
import { LanguageService } from '../../../../../shared/services/language.service';
import { TimeService } from '../../../../time/_api/services/time.service';
import { AmsNotifierService } from '../../../../../shared/services/ams-notifier.service';

@Component({
  selector: 'app-project-portal-approval-week',
  templateUrl: './project-portal-approval-week.component.html',
  styleUrls: ['./project-portal-approval-week.component.css']
})
export class ProjectPortalApprovalWeekComponent implements OnInit {
  @ViewChild(DxDataGridComponent, {static: false}) dataGrid: DxDataGridComponent
  updatedObject: any;
  selectedDate: Date;
  weekno_text: any;
  zoomLevels: string[] = [
    "month", "year", "decade", "century"
  ];
  employees: any[];
  employeeLookUpEnabled: boolean = true;
  newStatusId = 3;
  newCategoryId = 9;

  timetypes: any[];
  projectsDataSource: DataSource;
  selectedEmployeeId: number = -1;
  isEmployeeSelectShown: boolean;
  projectIdsDataSource: any[];
  dataSourceWeekApproval: any;
  isLoadIndicatorVisible: boolean;
  // employeeDataSource: CustomStore;


  popupVisible = false;
  customerPopupDataSource: DataSource;
  projectsPopupDataSource: DataSource;
  projectPopupSearchEnabled = true;
  selectedProjectIdPopup: number;
  selectedCustomerIdPopup: number;
  fromCellPopup: any;
  fromCellSelectItem: any;
  selectedProjectItemPopup: any;

  editorElement: any;

  isClone: boolean = false;
  cloneData: any;

  placeholderShortHours = "";
  placeholderShortMinutes = "";
  labels = {
    Approved: '',
    Confirmed: '',
    Unconfirmed: '',
    UnconfirmedTransport: '',
    ReadySalary: '',
    TransferredSalary: ''
  };
  colorCodeUnconfirmed = "#EE745D";
  colorCodeApproved = "#8CC588"
  colorUnconfirmed = this.colorCodeUnconfirmed;
  colorConfirmed = "";
  colorApproved = this.colorCodeApproved;

  @Output() loading = new EventEmitter<boolean>();//emit event to parent(project-portal.component) to show load indicator
  @ViewChild(GridEditWeekComponent, {static: false}) private gridEditWeekComponent: GridEditWeekComponent;


  constructor(private userService: UserService, private dateTimeFunctions: DateTimeFunctions, private projectService: ProjectService, private languageService: LanguageService,
     private timeService: TimeService, private amsNotifierService: AmsNotifierService) {
    this.selectedDate = new Date();
    this.weekno_text = this.dateTimeFunctions.findWeekFromDate(this.selectedDate);
    this.isEmployeeSelectShown = true;
    this.labels.Approved = this.languageService.LNG("Label.Is.Approved");
    this.labels.Confirmed = this.languageService.LNG("Label.Confirmed");
    this.labels.Unconfirmed = this.languageService.LNG("Label.Unconfirmed");
    this.labels.UnconfirmedTransport = this.languageService.LNG("Label.Unconfirmed") + " " + this.languageService.LNG("Label.Transport");
    this.labels.ReadySalary = this.languageService.LNG("Label.Ready.For.Salary");
    this.labels.TransferredSalary = this.languageService.LNG("Label.Transferred.Salary");
    this.placeholderShortHours = this.languageService.LNG("Label.ShortHours");
    this.placeholderShortMinutes = this.languageService.LNG("Label.ShortMinutes");
    this.newStatusId = 3;
    this.newCategoryId = 9;
  }

  ngOnInit() {
    this.getTimeTypes();
    this.setLookUps();
  }

  getDataSourceProjects(e) {

    return this.projectService.get().toPromise();
  }

  setLookUps() {

    // project
    this.projectsDataSource = new DataSource({
      key: "ProjectId",
      load: (loadOptions) => {
        if (this.projectIdsDataSource && this.projectIdsDataSource.length > 0) {
          if (loadOptions.searchValue != null) {
            return this.projectService.getBySearchTextAndProjectIds(loadOptions.searchValue.toString(), this.projectIdsDataSource).toPromise();
          }
          else {
            return this.projectService.getByIds(this.projectIdsDataSource).toPromise();
            //return "";
          }
        }
        else {
          if (loadOptions.searchValue) {
            return this.projectService.getBySearchText(loadOptions.searchValue.toString()).toPromise();
          }
          else {
            return [];
          }
        }
      },
      byKey: (key) => {
        if (key > 0) {
          return this.projectService.getById(key).toPromise();
        }
        else {
          let p: any = {
            ProjectId: -1,
            CustomerId: -1,
            ProjectNumber: "",
            ProjectDisplayName: ""
          }
          return p;
        }
      }
    });

    //customer popup
    this.customerPopupDataSource = new DataSource({
      key: 'CustomerId',
      loadMode: "raw",
      load: (loadOptions) => {
        return this.projectService.getCustomers().toPromise();
      },
      byKey: (key) => {
        return this.projectService.getCustomer(key).toPromise();
      }
    });

    //project popup
    this.projectsPopupDataSource = new DataSource({
      key: "ProjectId",
      load: (loadOptions) => {

        if (loadOptions.searchValue != null) {
          return this.projectService.getBySearchTextAndProjectIds(loadOptions.searchValue.toString(), this.projectIdsDataSource).toPromise();
        }
        else {
          if (this.selectedCustomerIdPopup > 0) {
            return this.projectService.getByCustomerId(this.selectedCustomerIdPopup).toPromise();
          }
          else {
            return this.projectService.getByIds(this.projectIdsDataSource).toPromise();
            //return "";
          }
        }
      },
      byKey: (key) => {

        return this.projectService.getById(key).toPromise();
      }
    });

    // //employee
    // this.employeeDataSource = new CustomStore({
    //   key: 'EmployeeId',
    //   load: (loadOptions) => {
    //     if (loadOptions.searchValue != null) {
    //       return this.projectService.getEmployeesBySearchText(loadOptions.searchValue.toString()).toPromise();
    //     }
    //     else {
    //       return [];
    //     }
    //   },
    //   byKey: (key) => {
    //     if (key > 0) {
    //       return this.projectService.getEmployeeById(key).toPromise();
    //     }
    //     else {
    //       return {
    //         EmployeeId: -1,
    //         EmployeeNumber: "",
    //         Name: ""
    //       }
    //     }
    //   }
    // });
  }

  focusHHmm(e) {
    e.event.target.select();
  }

  //tab to minute field when tabbing from hour field. default behaviour of datagrid is tabbing to next gridcolumn
  onKeyDownHH(e) {

    if (!e.event.shiftKey && e.event.keyCode === 9) {

      e.event.stopImmediatePropagation();
    }
  }

  //needed to get values to hours and minute-boxes from displayValue because getting them from cell.data.MondaySecondsToHH f.ex does not get updated after first column has changed. tried this in the onValueChangedHours and onValueChangedMinutes functions
  getValueHours(cell) {

    let displayValue = cell.displayValue;
    if (displayValue) {
      var h = Math.floor(displayValue / 3600);
      var m = Math.floor(displayValue % 3600 / 60);
      // let indxT = displayValue.indexOf("t");
      // let indxm = displayValue.indexOf("m");
      // let hours = Number(displayValue.substring(0, indxT));
      // let min = Number(displayValue.substring(indxT + 1, indxm));

      return h;
    }
    else
    {
      return "";
    }
  }

  getValueMin(cell) {
    let displayValue = cell.displayValue;
    if (displayValue) {
      var h = Math.floor(displayValue / 3600);
      var m = Math.floor(displayValue % 3600 / 60);
      // let indxT = displayValue.indexOf("t");
      // let indxm = displayValue.indexOf("m");
      // let hours = Number(displayValue.substring(0, indxT));
      // let min = Number(displayValue.substring(indxT + 1, indxm));

      return m;
    }
    else {
      return "";
    }
  }

  onInitNewRow(e) {

    if (!this.isClone) {
      e.data.ProjectId = -1;
      e.data.ProjectDisplayName = "";
      if (this.employees && this.employees.length === 1) {
        e.data.EmployeeId = this.employees[0].EmployeeId;
      }
    }
    else {
      //clone project and employee
      e.data.ProjectId = this.cloneData.ProjectId;
      e.data.ProjectDisplayName = this.cloneData.ProjectDisplayName;
      e.data.CustomerId = this.cloneData.CustomerId;
      e.data.EmployeeId = this.cloneData.EmployeeId;
    }
    this.isClone = false;
  }

  projectTemplate(e) {

  }

  onProjectValueChanged(e, cell) {

    let selectedProject = e.component.option("selectedItem");
    if (selectedProject) {
      cell.setValue(selectedProject);
      cell.data.ProjectId = selectedProject.ProjectId;
      cell.data.ProjectDisplayName = selectedProject.ProjectDisplayName;
      cell.data.CustomerId = selectedProject.CustomerId;
    }
  }
  onEmployeeValueChanged(e, cell) {
    let selectedEmployee = e.component.option("selectedItem");
    if (selectedEmployee) {
      cell.setValue(selectedEmployee.EmployeeId);
      cell.data.EmployeeId = selectedEmployee.EmployeeId;
    }
  }

  setProjectValue(newData, value) {

    newData.ProjectId = value && value.ProjectId;
    newData.ProjectDisplayName = value && value.ProjectDisplayName;
    newData.CustomerId = value && value.CustomerId;
  }

  setHHmmValue(newData, value) {

    switch  (value.DayNumber) {
      case 1:
        newData.MondaySeconds = value && value.MondaySeconds;
        newData.MondayToHHmm = value && value.MondayToHHmm;
        value.MinuteBoxItem.firstChild.firstChild.firstChild.firstChild.focus();
        break;
      case 2:
        newData.TuesdaySeconds = value && value.TuesdaySeconds;
        newData.TuesdayToHHmm = value && value.TuesdayToHHmm;
        break;
    }
  }

  onRowPrepared(e) {

    if(e.isEditing) {

      var cellElements = e.rowElement.children(":not(.dx-command-edit)");

      cellElements.first().on("keydown", function(event) {

          if(event.keyCode === 9 && event.shiftKey) {
              event.preventDefault();
              e.component.focus(cellElements.last());
          }
      });

      cellElements.last().on("keydown", function(event) {

          if(event.keyCode === 9 && !event.shiftKey) {
              event.preventDefault();
              e.component.focus(cellElements.first());
          }
      });
    }
  }



  onCellPrepared(e) {

    if (e.rowType === "data") {
      //do not allow edit on confirmed time posts(statusid=4) and categoryid=1 when user is admin
      if (e.column.type === "buttons" && ((e.data.CategoryId === 1 || e.data.StatusId >= 4))) {
        for (let i = 0; i < e.cellElement.children.length; i++) {
          let child = e.cellElement.children[i];
          child.style.display = 'none';
        }
      }
      if (e.columnIndex == 0) {
        switch (e.key.StatusId) {
          case 2:
            for (let i = 0; i < e.cellElement.children.length; i++) {
              let child = e.cellElement.children[i];
              child.style.display = 'none';
            }
            break;
          case 3:
            break;
          case 4:
            break;
        }
      }
      if (e.columnIndex == 1) {
        
        e.cellElement.classList.add(e.key.StatusHtmlSettingClassValue);
        switch (e.key.StatusId) {
          case 2:
            e.cellElement.title = this.labels.Unconfirmed;
            if (e.key.CategoryId == 7) {
              e.cellElement.title = this.labels.UnconfirmedTransport;
            }
            break;
          case 3:
              e.cellElement.title = this.labels.Confirmed;
            break;
          case 4:
              e.cellElement.title = this.labels.Approved;
            break;
          case 5:
              e.cellElement.title = this.labels.ReadySalary;
            break;
        }
      }
    }
  }

  onEditorPreparing(e) {
    if (e.dataField === "EmployeeId" || e.dataField === "TimeTypeId") {
      if (e.row.data.StatusId === 4) {
        // e.showEditorAlways = false;
        e.readOnly = true;
        e.editorOptions.disabled = true;
      }
    }
  }

  onEditorPrepared(e) {
    // if (e.dataField === "EmployeeId" || e.dataField === "TimeTypeId") {
    //   if (e.row.data.StatusId === 4) {
    //     // e.showEditorAlways = false;
    //     e.readOnly = true;
    //     e.editorOptions.disabled = true;
    //   }
    // }
  }

  onValueChangedHoursMon(e, cell, daynumber) {


    let newValue: number;
    newValue = Number(e.value);
    cell.data.MondaySecondsToHH = newValue;
    let minutesMon = cell.data.MondaySecondsTomm;
    let newHHSeconds = newValue * 3600;
    let secondsMon = newHHSeconds + (Number(minutesMon) * 60);
    cell.setValue(secondsMon);

  }

  onValueChangedMinutesMon(e, cell, daynumber) {
    let newValue: number;
    newValue = Number(e.value);
    let newMinSeconds = newValue * 60;
    let hoursMon = cell.data.MondaySecondsToHH;
    let secondsMon = newMinSeconds + (Number(hoursMon) * 3600);
    cell.setValue(secondsMon);
  }

  onValueChangedHours(e, cell, daynumber) {

    let newValue: number;
    newValue = Number(e.value);
    let newHHSeconds = newValue * 3600;
    switch (daynumber) {
      case 1:
        cell.data.MondaySecondsToHH = newValue;
        cell.data.MondaySecondsTomm = cell.data.MondaySecondsTomm ? cell.data.MondaySecondsTomm : 0;
        let minutesMon = cell.data.MondaySecondsTomm;
        let secondsMon = newHHSeconds + (Number(minutesMon) * 60);
        cell.setValue(secondsMon);
        break;
      case 2:
        cell.data.TuesdaySecondsToHH = newValue;
        cell.data.TuesdaySecondsTomm = cell.data.TuesdaySecondsTomm ? cell.data.TuesdaySecondsTomm : 0;
        let minutesTue = cell.data.TuesdaySecondsTomm;
        let secondsTue = newHHSeconds + (Number(minutesTue) * 60);
        cell.setValue(secondsTue);
        break;
      case 3:
        cell.data.WednesdaySecondsToHH = newValue;
        cell.data.WednesdaySecondsTomm = cell.data.WednesdaySecondsTomm ? cell.data.WednesdaySecondsTomm : 0;
        let minutesWed = cell.data.WednesdaySecondsTomm;
        let secondsWed = newHHSeconds + (Number(minutesWed) * 60);
        cell.setValue(secondsWed);
        break;
      case 4:
        cell.data.ThursdaySecondsToHH = newValue;
        cell.data.ThursdaySecondsTomm = cell.data.ThursdaySecondsTomm ? cell.data.ThursdaySecondsTomm : 0;
        let minutesThu = cell.data.ThursdaySecondsTomm;
        let secondsThu = newHHSeconds + (Number(minutesThu) * 60);
        cell.setValue(secondsThu);
        break;
      case 5:
        cell.data.FridaySecondsToHH = newValue;
        cell.data.FridaySecondsTomm = cell.data.FridaySecondsTomm ? cell.data.FridaySecondsTomm : 0;
        let minutesFri = cell.data.FridaySecondsTomm;
        let secondsFri = newHHSeconds + (Number(minutesFri) * 60);
        cell.setValue(secondsFri);
        break;
      case 6:
        cell.data.SaturdaySecondsToHH = newValue;
        cell.data.SaturdaySecondsTomm = cell.data.SaturdaySecondsTomm ? cell.data.SaturdaySecondsTomm : 0;
        let minutesSat = cell.data.SaturdaySecondsTomm;
        let secondsSat = newHHSeconds + (Number(minutesSat) * 60);
        cell.setValue(secondsSat);
        break;
      case 7:
        cell.data.SundaySecondsToHH = newValue;
        cell.data.SundaySecondsTomm = cell.data.SundaySecondsTomm ? cell.data.SundaySecondsTomm : 0;
        let minutesSun = cell.data.SundaySecondsTomm;
        let secondsSun = newHHSeconds + (Number(minutesSun) * 60);
        cell.setValue(secondsSun);
        break;
      default:
    }
  }

  onValueChangedMinutes(e, cell, daynumber) {

    let newValue: number;
    newValue = Number(e.value);
    let newMinSeconds = newValue * 60;
    switch (daynumber) {
      case 1:
        cell.data.MondaySecondsTomm = newValue;
        cell.data.MondaySecondsToHH = cell.data.MondaySecondsToHH ? cell.data.MondaySecondsToHH : 0;
        let hoursMon = cell.data.MondaySecondsToHH;
        let secondsMon = newMinSeconds + (Number(hoursMon) * 3600);
        cell.setValue(secondsMon);
        break;
      case 2:
        cell.data.TuesdaySecondsTomm = newValue;
        cell.data.TuesdaySecondsToHH = cell.data.TuesdaySecondsToHH ? cell.data.TuesdaySecondsToHH : 0;
        let hoursTue = cell.data.TuesdaySecondsToHH;
        let secondsTue = newMinSeconds + (Number(hoursTue) * 3600);
        cell.setValue(secondsTue);
        break;
      case 3:
        cell.data.WednesdaySecondsTomm = newValue;
        cell.data.WednesdaySecondsToHH = cell.data.WednesdaySecondsToHH ? cell.data.WednesdaySecondsToHH : 0;
        let hoursWed = cell.data.WednesdaySecondsToHH;
        let secondsWed = newMinSeconds + (Number(hoursWed) * 3600);
        cell.setValue(secondsWed);
        break;
      case 4:
        cell.data.ThursdaySecondsTomm = newValue;
        cell.data.ThursdaySecondsToHH = cell.data.ThursdaySecondsToHH ? cell.data.ThursdaySecondsToHH : 0;
        let hoursThu = cell.data.ThursdaySecondsToHH;
        let secondsThu = newMinSeconds + (Number(hoursThu) * 3600);
        cell.setValue(secondsThu);
        break;
      case 5:
        cell.data.FridaySecondsTomm = newValue;
        cell.data.FridaySecondsToHH = cell.data.FridaySecondsToHH ? cell.data.FridaySecondsToHH : 0;
        let hoursFri = cell.data.FridaySecondsToHH;
        let secondsFri = newMinSeconds + (Number(hoursFri) * 3600);
        cell.setValue(secondsFri);
        break;
      case 6:
        cell.data.SaturdaySecondsTomm = newValue;
        cell.data.SaturdaySecondsToHH = cell.data.SaturdaySecondsToHH ? cell.data.SaturdaySecondsToHH : 0;
        let hoursSat = cell.data.SaturdaySecondsToHH;
        let secondsSat = newMinSeconds + (Number(hoursSat) * 3600);
        cell.setValue(secondsSat);
        break;
      case 7:
        cell.data.SundaySecondsTomm = newValue;
        cell.data.SundaySecondsToHH = cell.data.SundaySecondsToHH ? cell.data.SundaySecondsToHH : 0;
        let hoursSun = cell.data.SundaySecondsToHH;
        let secondsSun = newMinSeconds + (Number(hoursSun) * 3600);
        cell.setValue(secondsSun);
        break;
      default:
    }
  }

  getTimeTypes() {

    this.loading.emit(true);
    this.projectService.getTimeTypes()
      .subscribe((result: any) => { // success path

        this.loading.emit(false);
        this.timetypes = result;
      }, error => { // error path;
        this.loading.emit(false);
      });
  }

  onRefresh() {

    this.gridEditWeekComponent.loadListRecords(true);
  }

  onLoadRecords(viewModel) {

    if (this.projectIdsDataSource) {
      //no need to show loadindicator when using customstore
      //this.isLoadIndicatorVisible = true;
      viewModel.CategoryStatusCombos = this.getCatStatusCombos();
      this.selectedDate = viewModel.SelectedDate;

        this.dataSourceWeekApproval = new DataSource({
          // key: "WeekApprovalListItemId",
          load: (loadOptions) => {

            if (viewModel.RefreshSearchCriterias) {
              this.gridEditWeekComponent.clearDataGridSelections();
            }
            return this.projectService.getWeekApproval(viewModel).toPromise();
          },
          update: (key, values) => {

            let projectId = values.ProjectId;
            let timetypeId = values.TimeTypeId;
            values.CategoryId = 3;
            values.SelectedDate = this.selectedDate;
            // values.EmployeeId = this.selectedEmployeeId;
            return this.projectService.updateWeekApproval(values).toPromise().then((result: any) => { // success path
              this.loading.emit(false);
              if (result.IsSuccess) {
                this.amsNotifierService.success(this.languageService.LNG("Label.SavedOK"));
                if (result.Message != null && result.Message.length > 0) {
                  this.amsNotifierService.error(result.Message);
                }
                this.gridEditWeekComponent.onRefresh();
              }
              else {
                this.amsNotifierService.error(result.ErrorMessage);
              }
            }, error => { // error path;
              this.loading.emit(false);
            });
          },
          insert: (values) => {

            values.SelectedDate = this.selectedDate;
            values.CategoryId = 3;
            // values.EmployeeId = this.selectedEmployeeId;
            return this.projectService.addWeekApproval(values).toPromise().then((result: any) => {

              this.loading.emit(false);
              if (result.IsSuccess) {
                this.amsNotifierService.success(this.languageService.LNG("Label.SavedOK"));
                if (result.Message != null && result.Message.length > 0) {
                  this.amsNotifierService.error(result.Message);
                }
                this.gridEditWeekComponent.onRefresh();
              }
              else {
                this.amsNotifierService.error(result.ErrorMessage);
              }
            }, error => { // error path;
              this.loading.emit(false);
            });
          },
          remove: (key) => {

            this.loading.emit(true);
            return this.projectService.deleteWeekApproval(key).toPromise().then((result: any) => { // success path

              this.loading.emit(false);
              if (result.IsSuccess) {
                this.gridEditWeekComponent.onRefresh();
                if (result.Message != null && result.Message.length > 0) {
                  this.amsNotifierService.error(result.Message);
                }
              }
              else {
                this.amsNotifierService.error(result.ErrorMessage);
              }
            }, error => { // error path;
              this.loading.emit(false);
            });
          }
      });
    }
  }

  getCatStatusCombos() {
    //only look for categoryid 9 with status 3 and 4, and categoryid 1 with status 2
    let catstatusCombos = [];
    //Eirik 02.02.21 task 401 - show unconfirmed times
    catstatusCombos.push({
      CategoryId: 1,
      StatusId: 2,
    });
    //Eirik 17.08.21 task 854 - show unconfirmed transports.
    catstatusCombos.push( {
      CategoryId: 7,
      StatusId: 2,
    });
    catstatusCombos.push({
      CategoryId: 9,
      StatusId: 3,
      ShowEqualOrLargerThanStatus: true,
    });
    return catstatusCombos;
  }

  getViewModel(employeeId?: number) {

    //if only one employee, then only search for this employee
    let searchEmployeeId = -1;
    if (employeeId !== null && employeeId !== undefined && employeeId > 0) {
      searchEmployeeId = employeeId;
    }
    else {
      if (this.employees && this.employees.length === 1) {
        searchEmployeeId = this.employees[0].EmployeeId;
      }
    }
    //only look for categoryid 9 with status 3 and 4, and categoryid 1 with status 2
    let catstatusCombos = [];
    catstatusCombos.push({
      CategoryId: 1,
      StatusId: 2,
    });
    catstatusCombos.push({
      CategoryId: 9,
      StatusId: 3,
      ShowEqualOrLargerThanStatus: true,
    });
    // catstatusCombos.push({
    //   CategoryId: 9,
    //   StatusId: 4,
    // });

    let viewModel = {
      ProjectIds: this.projectIdsDataSource,
      SelectedDate: this.selectedDate,
      EmployeeId: searchEmployeeId,
      CategoryStatusCombos: catstatusCombos,
    }
    return viewModel;
  }

  isValid(data) {

    if (!(data.MondaySeconds > 0 || data.TuesdaySeconds > 0 || data.WednesdaySeconds > 0 || data.ThursdaySeconds > 0 ||
          data.FridaySeconds > 0 || data.SaturdaySeconds > 0 || data.SundaySeconds > 0)) {
      this.amsNotifierService.errorWithTimeout(this.languageService.LNG("Label.Please.Type.Hours"));
      return false;
    }

    return true;
  }

  onRowInserting(e) {
    const isCanceled = new Promise((resolve) => {      
      if (this.isValid(e.data)) {
        this.loading.emit(true);
        this.timeService.isTimeTypeAllowed(e.data.EmployeeId, e.data.TimeTypeId).subscribe((result: any) => {

          if (result.IsSuccess) {
            e.data.SelectedDate = this.selectedDate;
            e.data.CategoryId = this.newCategoryId;
            e.data.StatusId = this.newStatusId;

            this.projectService.addWeekApproval(e.data)
              .subscribe((result: any) => { // success path                
                this.loading.emit(false);
                if (result.IsSuccess) {
                  resolve(false);
                  this.amsNotifierService.success(this.languageService.LNG("Label.SavedOK"));
                  e.component.cancelEditData();
                  if (result.Message != null && result.Message.length > 0) {
                    this.amsNotifierService.error(result.Message);
                  }
                  this.gridEditWeekComponent.onRefresh();
                }
                else {
                  resolve(true);
                  this.amsNotifierService.error(result.ErrorMessage);
                }
              }, error => { // error path;
                this.loading.emit(false);
                resolve(true);
              });
          }
          else {
            this.loading.emit(false);
            resolve(true);
            this.amsNotifierService.error(result.ErrorMessage);
          }
        }, error => { // error path;
          this.amsNotifierService.error("Something went wrong during edit");
          this.loading.emit(false);
          resolve(true);
        });
      }
      else {
        this.loading.emit(false);
      }
    });
    e.cancel = isCanceled;
  }

  onRowUpdating(e) {
    const isCanceled = new Promise((resolve) => {
      this.loading.emit(true);
      for (var property in e.oldData) {
        if (!e.newData.hasOwnProperty(property)) {
          e.newData[property] = e.oldData[property];
        }
      }

      let updatedObject = e.newData;
      updatedObject.CategoryId = this.newCategoryId;
      updatedObject.StatusId = this.newStatusId;
      updatedObject.SelectedDate = this.selectedDate;
      this.timeService.isTimeTypeAllowed(updatedObject.EmployeeId, updatedObject.TimeTypeId).subscribe((result: any) => {
        if (result.IsSuccess) {
          this.projectService.updateWeekApproval(updatedObject)
            .subscribe((result: any) => { // success path
              this.loading.emit(false);
              if (result.IsSuccess) {
                resolve(false);
                this.amsNotifierService.success(this.languageService.LNG("Label.SavedOK"));
                if (result.Message != null && result.Message.length > 0) {
                  this.amsNotifierService.error(result.Message);
                }
                e.component.cancelEditData();
                this.gridEditWeekComponent.onRefresh();
              }
              else {
                this.amsNotifierService.error(result.ErrorMessage);
                resolve(true);
              }
            }, error => { // error path;
              this.loading.emit(false);
              resolve(true);
            });
        }
        else {
          this.loading.emit(false);
          this.amsNotifierService.error(result.ErrorMessage);
          resolve(true);
        }

      }, error => { // error path;
        this.amsNotifierService.error("Something went wrong during edit");
        this.loading.emit(false);
        resolve(true);
      });
    });
    e.cancel = isCanceled;
  }

  onRowUpdated(e) {

  }

  saveEditData() {
    this.gridEditWeekComponent.dataGrid.instance.saveEditData();
  }

  cancelEditData() {
    this.gridEditWeekComponent.dataGrid.instance.cancelEditData();
  }

  checkUnsavedChanges(): Promise<boolean> {

    let hasEditData = this.gridEditWeekComponent.dataGrid.instance.hasEditData();
    return new Promise(resolve => {
    if (hasEditData) {
        var res = confirm(this.languageService.LNG("Label.Do.You.Want.To.Save.Changes.Before.Continuing",), this.languageService.LNG("Label.Unsaved.Changes"));
          res.then((yes: boolean) => {

            if (yes) {
              resolve(true);
            }
            else {
              resolve(false);
            }
          });
      }
      else {
        resolve(false);
      }
    })
  }

  showPopupProject(selectedProjectId, selectedCustomerId, cell) {

    this.popupVisible = true;
    this.selectedProjectIdPopup = selectedProjectId ? selectedProjectId : -1;
    if (selectedProjectId <= 0 || !selectedProjectId) {
      this.selectedCustomerIdPopup = -1;
    }
    this.fromCellPopup = cell;
    // this.fromCellSelectItem = this.fromCellPopup.cellElement.firstChild.firstChild.firstChild.firstChild.firstChild.firstChild;
  }

  onPopupCustomerChanged(e) {

    this.projectPopupSearchEnabled = false;
    // this.projectPopupDataSource.filter(['CustomerId', '=', e.value]);
    this.selectedCustomerIdPopup = e.value;
    this.projectsPopupDataSource.reload();
  }

  onPopupProjectChanged(e) {

    this.selectedCustomerIdPopup = e.selectedItem.CustomerId;
    this.selectedProjectItemPopup = e.selectedItem;
  }

  //when ok is clicked, then set cellvalue using setValue and also set cell.data so that the correct data is displayed in the selectbox
  onClickPopupSelectedProject(e) {

    this.popupVisible = false;
    this.fromCellPopup.setValue(this.selectedProjectItemPopup);
    this.fromCellPopup.data.ProjectId = this.selectedProjectItemPopup.ProjectId;
    this.fromCellPopup.data.ProjectDisplayName = this.selectedProjectItemPopup.ProjectDisplayName;
    this.fromCellPopup.data.CustomerId = this.selectedProjectItemPopup.CustomerId;
  }

  getSelectedRowsData() {
    return this.gridEditWeekComponent.getSelectedRowsData();
  }

  onReset(statusId): Promise<boolean> {
    return new Promise(resolve => {
      this.gridEditWeekComponent.onReset(statusId).then((resetOk:any)=>{
        
        if (resetOk) {
          resolve(true);
        }
        else {
          resolve(false);
        }
      });
    });
  }

  onApprove () {
    this.gridEditWeekComponent.onApprove();
  }

  onCopyRow(e, cell) {

    this.isClone = true;
    this.cloneData = cell.data;
  }

  onDeleteRow(e, cell) {


    this.loading.emit(true);
    this.projectService.deleteWeekApproval(cell.data).subscribe((result: any) => { // success path

      this.loading.emit(false);
      this.gridEditWeekComponent.onRefresh();
      // this.dataGrid.instance.refresh();
    }, error => { // error path;
      this.loading.emit(false);
    });
  }

  @Input()
  set employeeDataSource(recs: any) {

    this.employees = recs;
    if (this.employees && this.employees.length === 1) {
      this.employeeLookUpEnabled = false;
    }
  }

  // @Input()
  // set selectedEmployee(employeeId: any) {
  //
  //   this.selectedEmployeeId = employeeId;
  // }

  @Input()
  set showEmployeeSelect(visible: boolean) {

    this.isEmployeeSelectShown = visible;
  }

  @Input()
  set projectIds(ids: any[]) {
    this.projectIdsDataSource = ids;
  }

  dataCellTemplate(e, d) {


  }

  onLoadingDetail(loading: boolean) {
    this.loading.emit(loading);
  }
}
